import React from 'react';
import { Form, Input, Button,Row,Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../assets/css/CriarConta.css';// Arquivo CSS para centralizar e estilizar

const Recover = () => {
  const navigate = useNavigate();

  const onFinish = (values) => {
    console.log('Dados para recuperação:', values);
    // Lógica para recuperação de senha aqui
  };

  return (
    <div className="container">
      <div className="form-box">
        <h2 style={{ textAlign: 'center' }}>Recuperar Senha</h2>
        <Form name="recover_password" onFinish={onFinish} style={{ marginTop: 20 }}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Por favor, insira seu e-mail!' },
              { type: 'email', message: 'Insira um e-mail válido!' },
            ]}
          >
            <Input placeholder="E-mail" />
          </Form.Item>

          <Row gutter={16}>
          <Col span={12}>
          <Form.Item>
            <Button
              style={{ width: '100%' }}
              onClick={() => navigate('/')}
            >
              Cancelar
            </Button>
          </Form.Item>

          </Col>

          <Col span={12}>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Enviar
            </Button>
          </Form.Item>
          </Col>
          </Row>


         

         
        </Form>
      </div>
    </div>
  );
};

export default Recover;
